export function getPreviousNetworkGrading(networkGradings, year, mustBeSurvey = false) {
    for (let i = networkGradings.length - 1; i >= 0; i--) {
        if (networkGradings[i].year <= year && (!mustBeSurvey || networkGradings[i].yearRelative === 0)) {
            return networkGradings[i]
        }
    }

    return null
}